import React, { useState } from "react";
import { useLang } from "../contexts/LanguageContext";
import Logo from "../components/Logo";
import SettingsOffCanvas from "./SettingsOffCanvas";
import { getAuth } from "firebase/auth";

import ProfileDefault from "../images/profile-default.svg";

export default function Navbar() {
  const { t } = useLang();

  const auth = getAuth();
  const user = auth.currentUser;
  const photoURL = user?.photoURL;

  const [showSettings, setShowSettings] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const logout = () => {
    auth.signOut()
      .then(() => {
        window.location.href = "/index";
      })
      .catch((err) => {
        console.error("Error al cerrar sesión:", err);
        window.location.href = "/index";
      });
  };

  const handleOpenSettings = () => {
    setShowSettings(true);
  };

  const handleCloseSettings = () => {
    setShowSettings(false);
  };

  const handleLogout = () => {
    handleCloseSettings();
    logout();
  };

  const toggleNavbar = () => {
    setIsNavCollapsed((prev) => !prev);
  };

  const handleNavLinkClick = () => {
    setIsNavCollapsed(true);
  };

  return (
    <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
      <div className="container-fluid">
        <Logo LOGO_TEXT={t("LOGO_TEXT")} />

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarCollapse"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
          onClick={toggleNavbar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse${isNavCollapsed ? "" : " show"}`}
          id="navbarCollapse"
        >
          <ul className="navbar-nav me-auto mb-2 mb-md-0">
            <li className="nav-item">
              <a
                className="nav-link active"
                aria-current="page"
                href="/home"
                onClick={handleNavLinkClick}
              >
                <svg
                  className="menu_icon bi bi-house"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
                </svg>
                <span className="nav_menu_text">{t("HOME_MENU_HOME")}</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link active" href="/list" onClick={handleNavLinkClick}>
                <svg
                  className="menu_icon bi bi-bookmark-plus"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4" />
                </svg>
                <span className="nav_menu_text">{t("HOME_MENU_MY_LIST")}</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link active" href="/search" onClick={handleNavLinkClick}>
                <svg
                  className="menu_icon bi bi-search"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
                <span className="nav_menu_text">{t("HOME_MENU_SEARCH")}</span>
              </a>
            </li>
          </ul>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn btn-secondary user_button"
              onClick={handleOpenSettings}
              aria-label={t("HOME_MENU_SETTINGS")}
              style={{
                backgroundImage: `url('${photoURL || ProfileDefault}')`
              }}
            >
              <span className="visually-hidden">{t("HOME_MENU_SETTINGS")}</span>
            </button>
          </div>
        </div>
      </div>
      <SettingsOffCanvas
        show={showSettings}
        onClose={handleCloseSettings}
        onLogout={handleLogout}
      />
    </nav>
  );
}
